/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const publicBookingPageDataStatusSchema = z.enum(['pending', 'booked', 'cancelled', 'expired', 'invalidated'])

export type PublicBookingPageDataStatusSchema = z.infer<typeof publicBookingPageDataStatusSchema>
